var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tienda",attrs:{"id":"tienda"}},[_c('v-toolbar',{staticClass:"sub-toolbar",attrs:{"flat":""}},[_c('Menu')],1),_c('ProductsList',{attrs:{"tienda":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }